module.exports = __webpack_public_path__ + "static/and-ourselves-A-c1b0ab6b3b2be9787d667d5bb0486c72.png";